<template>
    <b-card>
        <validation-observer ref="observer" v-slot="{ passes, invalid }">
            <b-modal title="Create New Order - Options" id="confirm-order-modal" ok-title="Create Order"
                     v-model="modalShow"
                     :ok-disabled="invalid"
                     :busy="isBusy"
                     @ok="handleOk">
                <h5>Please enter order details:</h5>

                <b-form>
                    <validation-provider
                        name="Brand"
                        :rules="{ required: true }"
                        immediate
                        v-slot="validationContext"
                    >
                        <b-form-group
                            id="input-group-brand"
                            label="Brand:"
                            label-for="input-brand"
                        >
                            <b-form-select v-model="brandSelected" :options="brandOptions" id="input-brand"
                                           :state="getValidationState(validationContext)"
                            ></b-form-select>
                        </b-form-group>
                    </validation-provider>

                    <validation-provider
                        name="Shipping Method"
                        :rules="{ required: true }"
                        immediate
                        v-slot="validationContext"
                    >
                        <b-form-group
                            id="input-group-shipping"
                            label="Shipping Method:"
                            label-for="input-shipping-method"
                        >
                            <b-form-select v-model="shippingSelected" :options="shippingOptions"
                                           id="input-shipping-method"
                                           :state="getValidationState(validationContext)"
                            ></b-form-select>
                        </b-form-group>
                    </validation-provider>

                    <validation-provider
                        name="Tracking Number"
                        :rules="{ required: true }"
                        immediate
                        v-slot="validationContext"
                    >
                        <b-form-group
                            id="input-group-tracking"
                            label="Tracking Number:"
                            label-for="input-tracking-number"
                        >
                            <b-form-input v-model="trackingNumber" type="text" id="input-tracking-number"
                                          :state="getValidationState(validationContext)"
                            ></b-form-input>
                        </b-form-group>
                    </validation-provider>
                </b-form>
            </b-modal>
        </validation-observer>
        <validation-observer ref="observer" v-slot="{ passes, invalid }">
            <b-modal title="Create New Packaging - Options" id="confirm-order-modal" ok-title="Create Packaging"
                     v-model="modalNewPackageShow"
                     :ok-disabled="invalid"
                     :busy="isBusy"
                     @ok="handleOKAddPackage">
                <h5>Please enter order details:</h5>

                <b-form>
                    <validation-provider
                        name="Order Id"
                        :rules="{ required: true }"
                        immediate
                        v-slot="validationContext"
                    >
                        <b-form-group
                            id="input-group-order-id"
                            label="Order Id:"
                            label-for="input-order-id"
                        >
                            <b-form-input v-model="orderId" id="input-order-id"
                                          :state="getValidationState(validationContext)"
                            ></b-form-input>
                        </b-form-group>
                    </validation-provider>

                    <validation-provider
                        name="Shipping Method"
                        :rules="{ required: true }"
                        immediate
                        v-slot="validationContext"
                    >
                        <b-form-group
                            id="input-group-shipping-2"
                            label="Shipping Method:"
                            label-for="input-shipping-method"
                        >
                            <b-form-select v-model="shippingSelected" :options="shippingOptions"
                                           id="input-shipping-method-2"
                                           :state="getValidationState(validationContext)"
                            ></b-form-select>
                        </b-form-group>
                    </validation-provider>

                    <validation-provider
                        name="Tracking Number"
                        :rules="{ required: true }"
                        immediate
                        v-slot="validationContext"
                    >
                        <b-form-group
                            id="input-group-tracking"
                            label="Tracking Number:"
                            label-for="input-tracking-number"
                        >
                            <b-form-input v-model="trackingNumber" type="text" id="input-tracking-number"
                                          :state="getValidationState(validationContext)"
                            ></b-form-input>
                        </b-form-group>
                    </validation-provider>
                </b-form>
            </b-modal>
        </validation-observer>
        <b-row v-if="pageMode === 'not-found'">
            <b-col>
                <b-alert show variant="danger"><i class="fa-duotone fa-exclamation-triangle fa-2x fa-fw"></i> <span class="h3">Order not found!</span>
                </b-alert>
            </b-col>
        </b-row>

        <b-row class="mb-3">
            <b-col>
                <h3>Search for a customer:</h3>
                <b-form @submit="getCustomers">
                    <b-form-group
                        id="input-group-1"
                        label="Customer's Name:"
                        label-for="input-1"
                    >
                        <label class="sr-only" for="inline-form-input-name">Name</label>
                        <b-form-input
                            id="input-1"
                            v-model="form.name"
                            type="text"
                            required
                            placeholder="Jane Doe"
                        ></b-form-input>
                    </b-form-group>

                    <b-button type="submit" variant="primary">Search</b-button>
                </b-form>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <b-table id="intake-outstanding-results" ref="intakeOutstandingResults" striped hover borderless
                         v-if="showTable"
                         thead-tr-class="text-center"
                         tbody-tr-class="text-center"
                         head-variant="dark"
                         no-provider-paging
                         no-provider-sorting
                         no-provider-filtering
                         show-empty
                         :busy.sync="isBusy"
                         :fields="fields"
                         :items="items">
                    <template v-slot:head(actions)="data">
                    </template>
                    <template v-slot:cell(address)="data">
                        <div>{{ data.item.address.address1 }}</div>
                        <div v-if="data.item.address.address2">{{ data.item.address.address2 }}</div>
                        <div>{{ data.item.address.city }}, {{ data.item.address.state }} {{ data.item.address.zip }}
                        </div>
                    </template>
                    <template v-slot:cell(order_id)="data">
                        <div>{{
                                data.item.orders && data.item.orders.data && data.item.orders.data.length != 0 ? data.item.orders.data[data.item.orders.data.length - 1].id : 'Unknown'
                            }}
                        </div>
                    </template>

                    <template v-slot:cell(full_name)="data">
                        {{ data.item.first_name }} {{ data.item.last_name }}
                    </template>

                    <template v-slot:cell(actions)="data">
                        <template v-if="pageMode === 'not-found'">
                            <b-button v-if="data.item.latest_order && data.item.latest_order.status_id <= 6"
                                      @click="confirmCreatePackagingForExisting(data.item.id,data.item.latest_order.id)"
                                      variant="primary"><i
                                class="fa-regular fa-boxes fa-fw"></i> Add To Latest Order
                            </b-button>
                            &nbsp;
                            <b-button @click="confirmCreateOrderForCustomer(data.item.id)" variant="primary"><i
                                class="fa-regular fa-cart-plus fa-fw"></i> Create Order
                            </b-button>
                        </template>

                        <template v-if="pageMode === 'search'">
                            <b-button
                                @click="getTrackingByOrder(data.item.orders.data[data.item.orders.data.length-1].id)"
                                variant="primary" class="ml-2"><i
                                class="fa-regular fa-barcode-read fa-fw"></i> Re-Print Tracking
                            </b-button>
                        </template>
                    </template>
                    <template v-slot:table-busy>
                        <LoadingSpinner :busy="isBusy"></LoadingSpinner>
                    </template>
                </b-table>
            </b-col>
        </b-row>
        <b-modal v-model="modalTrackingShow" size="lg" title="Available Tracking Numbers" ok-only ok-title="Close"
                 ok-variant="secondary">
            <b-table borderless small head-variant="dark" :tbody-tr-class="modalTrackingRowClass"
                     :busy="modalTrackingBusy" :fields="modalTrackingFields" :items="modalTrackingItems">
                <template v-slot:table-busy>
                    <LoadingSpinner :busy="modalTrackingBusy"></LoadingSpinner>
                </template>
                <template v-slot:cell(tracking_number_type)="data">
                    <div v-if="data.value === 'print'">
                        <i class="fa-duotone fa-lg fa-print fa-fw" v-b-tooltip.hover.left :title="data.value | titleCase"></i>
                    </div>
                    <div v-else-if="data.value === 'mail'">
                        <i class="fa-duotone fa-lg fa-mailbox fa-fw" v-b-tooltip.hover.left
                           :title="data.value | titleCase"></i>
                    </div>
                    <div v-else-if="data.value === 'alternate'">
                        <span class="font-weight-bold">ALT</span>
                    </div>
                    <div v-else>
                        {{ data.value | titleCase }}
                    </div>
                </template>
                <template v-slot:cell(master_label)="data">
                    <i class="fa-solid fa-star text-info" v-if="data.value === 1"></i>
                    <div v-else>
                        <small><i class="fa-solid fa-sort-size-up"></i> {{ data.item.master_tracking_number }}</small>
                    </div>
                </template>
                <template v-slot:cell(shipper.carrier)="data">
                    <div class="text-center" v-if="data.value === 'FedEx'"><i class="fa-brands fa-2x fa-fedex"></i></div>
                    <div class="text-center" v-else-if="data.value === 'UPS'"><i class="fa-brands fa-2x fa-ups"></i></div>
                    <div class="text-center" v-else-if="data.value === 'USPS'"><i class="fa-brands fa-2x fa-usps"></i></div>
                    <div class="text-center" v-else>{{ data.value }}</div>
                </template>
                <template v-slot:cell(actions)="data">
                    <b-button :variant="modalTrackingButtonClass(data.item)" size="sm" :disabled="data.item.printing || !data.item.label_url"
                              @click="getPrintAsset(data.item)">
                        <i class="fa-regular fa-spinner fa-spin fa-fw" v-if="data.item.printing"></i>
                        <i class="fa-regular fa-print fa-fw" v-else></i>
                        <span v-if="modalTrackingIsInbound(data.item)">Re-Print Inbound</span>
                        <span v-else>Re-Print</span>
                    </b-button>
                </template>
            </b-table>
        </b-modal>
    </b-card>
</template>

<script>
import LoadingSpinner from '@/components/LoadingSpinner';
import {each} from 'lodash';

export default {
    name: 'intake-not-found',
    components: {
        LoadingSpinner
    },
    data() {
        return {
            pageMode: 'not-found',
            isBusy: false,
            showTable: false,
            chosenCustomerId: null,
            orderId: null,
            modalShow: null,
            modalNewPackageShow: null,
            modalTrackingShow: false,
            modalTrackingBusy: false,
            modalTrackingFields: [
                {key: 'tracking_number_type', label: 'Type', class: ''},
                {key: 'tracking_number', label: 'Tracking Number', class: ''},
                {key: 'master_label', label: 'Master Label', class: ''},
                {key: 'label_count', label: 'Label Count', class: ''},
                {key: 'shipper.name', label: 'Method', class: ''},
                {key: 'shipper.carrier', label: 'Carrier', class: ''},
                {key: 'actions', label: '', class: 'text-right'},
            ],
            modalTrackingItems: [],
            fields: [
                {key: 'id', label: 'Customer #', class: 'text-center'},
                {key: 'order_id', label: 'Order #', class: 'text-center'},
                {key: 'full_name', label: 'Name', class: 'text-center'},
                {key: 'address', label: 'Address', class: 'text-center'},
                {key: 'actions', label: 'Actions', class: 'text-right'},
            ],
            items: [],
            form: {
                name: null,
                order_id: null,
            },
            shippingSelected: null,
            shippingOptions: [],
            brandSelected: 1,
            brandOptions: [],
            trackingNumber: this.$route.params.tracking_number,
        };
    },
    created() {
        // Set up page mode based on scanned tracking number presence in route params
        if (!this.$route.params.tracking_number) {
            this.pageMode = 'search';
        }

        this.$http.get('/shippers')
            .then(response => {
                each(response.data.data, item => {
                    this.shippingOptions.push({value: item.id, text: item.carrier + ' - ' + item.name});
                });
            });
        this.$http.get('/brands')
            .then(response => {
                each(response.data.data, item => {
                    this.brandOptions.push({value: item.id, text: item.name});
                });
            });

        this.$qz.connect();
    },
    methods: {
        getValidationState({dirty, validated, valid = null}) {
            return dirty || validated ? valid : null;
        },
        getCustomers(event) {
            var _this = this;
            event.preventDefault();
            this.isBusy = true;
            this.showTable = true;
            this.$http.get('/search/customers', {
                params: {
                    q: this.form.name,
                },
            })
                .then(response => {
                    let itemsSeperate = response.data.data;
                    let itemsFinal = [];
                    for (let i = 0; i < itemsSeperate.length; i++) {
                        let orders = itemsSeperate[i].orders.data;
                        for(let j = 0; j < orders.length; j++) {

                            let order = orders[j];
                            if (order.status_id < 6) { //only allow appraisal and lower kits into search. (5 being appraisal, 6 being appraisal-hold).
                                let copy = _.cloneDeep(itemsSeperate[i]);
                                copy.latest_order = order;
                                copy.orders.data = [order];

                                itemsFinal.push(copy);
                            }
                        }
                    }
                    this.items = itemsFinal;
                    _this.isBusy = false;
                });
        },
        confirmCreateOrderForCustomer(id) {
            this.chosenCustomerId = id;
            this.modalShow = true;
        },
        confirmCreatePackagingForExisting(id, order_id) {
            this.chosenCustomerId = id;
            this.orderId = order_id;
            this.modalNewPackageShow = true;
        },
        handleOk(bvModalEvt) {
            bvModalEvt.preventDefault();
            this.createOrderForCustomer();
        },
        handleOKAddPackage(bvModalEvt) {
            bvModalEvt.preventDefault();
            this.addTrackingToOrder();
        },
        addTrackingToOrder() {
            this.showTable = false;
            this.isBusy = true;
            this.$http.post('/orders/' + this.orderId + '/trackingnumbers', {
                order_id: this.orderId,
                shipper_id: this.shippingSelected,
                tracking_number: this.trackingNumber,
                tracking_number_type: 'alternate',
                status: 'delivered',
            })
                .then(response => {
                    console.log(response);
                    this.$router.replace({
                        path: '/intake/view/' + response.data.data.tracking_number,
                        query: {order: response.data.data.order_id}
                    })
                        .catch(err => {
                            console.log(err);
                        });
                });

        },
        createOrderForCustomer() {
            this.showTable = false;
            this.isBusy = true;
            let payload = {
                brand_id: this.brandSelected,
                payment_method: 'company-check'
            };
            this.$http.post('/customers/' + this.chosenCustomerId + '/orders', payload)
                .then(response => {
                    this.orderId = response.data.data.id;
                    this.addTrackingToOrder();
                });
        },
        getTrackingByOrder(order_id) {
            this.modalTrackingBusy = true;
            this.modalTrackingShow = true;
            this.$http.get('/orders/' + order_id + '/trackingnumbers')
                .then(response => {
                    console.log(response);
                    this.modalTrackingBusy = false;
                    this.modalTrackingItems = response.data.data;
                    this.modalTrackingItems.forEach(item => {
                        this.$set(item, 'printing', false);
                    });
                });

        },
        modalTrackingRowClass(item, type) {
            if (!item || type !== 'row') return;
            if (item.expected_delivery_at) return 'bg-warning text-dark';
            return 'text-muted';
        },
        modalTrackingButtonClass(item) {
            if (item.expected_delivery_at) {
                return 'primary';
            } else {
                return 'secondary';
            }
        },
        modalTrackingIsInbound(item) {
            if (item.expected_delivery_at) {
                return true;
            } else {
                return false;
            }
        },
        getPrintAsset(item) {
            item.printing = true;
            let env_bucket = process.env.VUE_APP_BUCKET || 'b79-gx-media';
            if (item.label_url && (item.label_url.match(/.zpl$/i) || item.label_url.match(/.zpl2$/i))) {
                this.$http.get('https://' + env_bucket + '.s3.amazonaws.com' + item.label_url, {
                    withCredentials: false,
                    headers: {'Authorization': ''}
                })
                    .then(async (response) => {
                        console.log(response);
                        await this.$printer.printRaw('fedex', response.data);
                        item.printing = false;
                    });
            } else {
                this.$label('fedex', item, 'barcode').then(() => {
                    item.printing = false;
                    window.open('https://' + env_bucket + '.s3.amazonaws.com' + item.label_url, '_blank');
                });
            }
        }
    }
};
</script>

<style scoped>

</style>
